export default {
  deviceAuthorization: {
    createActivationCode: 'Generate Activation Code',
    activationDetail: 'Activation Code Details',
    activationQrCode: 'Activation Code QR Code',
    downloadQrCode: 'Download QR Code',
    qrPlaceholder: 'No QR code preview available',
    quotaOverview: 'Available Quota',
    quotaOverviewDesc: 'Generating activation codes consumes available quota. Voided or expired codes only return the unactivated portion.',
    noQuotaData: 'No quota data',
    availableQuota: 'Available Quota',
    availableQuotaCount: 'Available quota: {count}',
    basicInfo: 'Basic Information',
    selectDeviceQuota: 'Select Device Quota',
    selectedDeviceCount: '{count} devices selected',
    quotaUsageTip: 'Generating an activation code consumes the corresponding device quota. Unactivated quota is returned after voiding or expiration.',
    deadlineHelp: 'This only controls the activation code expiration date, not the device validity period. Activation is available until 23:59:59 on the selected date.',
    plannedDeviceType: 'Planned Device Type',
    planned: 'Planned',
    windowsCashier: 'Windows Cashier',
    posMachine: 'POS Machine',
    gateMachine: 'Gate',
    ticketMachine: 'Self-service Ticket Machine',
    coinSaleMachine: 'Self-service Coin Dispenser',
    coinDepositMachine: 'Self-service Coin Deposit Machine',
    ticketDepositMachine: 'Self-service Ticket Deposit Machine',
    vendingMachine: 'Vending Machine',
    activationCode: 'Activation Code',
    activationShop: 'Activation Store',
    includedDevice: 'Included Device',
    activationStatus: 'Activation Status',
    quantity: 'Quantity',
    activatedQuantity: 'Activated Quantity',
    quotaHandling: 'Quota Handling',
    activatableDeadline: 'Activatable Deadline',
    createTime: 'Created Time',
    deviceType: 'Device Type',
    pendingActivation: 'Pending Activation',
    partialActivation: 'Partially Activated',
    activated: 'Activated',
    expired: 'Expired',
    voided: 'Voided',
    unknownStatus: 'Unknown Status',
    unknownDeviceType: 'Unknown Device Type',
    detail: 'Details',
    qrCode: 'QR Code',
    qrUnavailable: 'The current status does not support viewing or downloading the QR code',
    qrLoadFailed: 'Failed to load the QR code. Please try again later',
    listLoadFailed: 'Failed to load the activation code list. Current data has been kept',
    quotaLoadFailed: 'Failed to load quota data. Current data has been kept',
    deviceTypeLoadFailed: 'Failed to load device types. Please try again later',
    detailLoadFailed: 'Failed to load activation code details. Please try again later',
    voidActivationCode: 'Void',
    voidConfirmTitle: 'Confirm Activation Code Void',
    voidConfirmContent: 'After voiding, the unactivated portion cannot be activated and the corresponding quota will be returned. Activated devices are not affected. Continue?',
    voidSuccess: 'Activation code voided successfully',
    voidFailed: 'Failed to void the activation code. Please try again later',
    frozenQuotaCount: 'Frozen {count}',
    returnedQuotaCount: 'Returned {count}',
    selectActivationShop: 'Please select an activation store',
    systemGenerated: 'Generated by System',
    selectDeadline: 'Please select an activatable deadline',
    createQuantity: 'Generation Quantity',
    quantityGreaterThanZero: 'The generation quantity must be greater than 0',
    selectAtLeastOneDevice: 'Select at least one device type and enter a generation quantity',
    quantityExceedQuota: 'The generation quantity cannot exceed the available quota',
    deadlineRangeTip: 'The deadline must be within 7 calendar days including today',
    invalidTimeRange: 'The start time cannot be later than the end time',
    createSuccess: 'Activation code generated successfully',
    createFailed: 'Failed to generate activation code. Please try again later',
    activationDetailList: 'Activation Details',
    deviceCode: 'Device Code',
    activatedTime: 'Activated Time',
    unbound: 'Unbound',
  },
};
